import React from 'react';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';

const DEFAULT_TOOLTIP_ID = 'tag-tooltip';

export enum TagTypes {
  Danger = 'danger',
  Neutral = 'neutral',
  Success = 'success',
  Warning = 'warning'
}

const TAG_COLORS = {
  [TagTypes.Danger]: 'bg-red-500',
  [TagTypes.Neutral]: 'bg-gray-500',
  [TagTypes.Success]: 'bg-green-500',
  [TagTypes.Warning]: 'bg-yellow-500'
};

type Props = {
  label?: string;
  id?: string;
  type?: TagTypes;
  children?: React.ReactNode;
};

const Tag: React.FC<Props> = ({
  label,
  children,
  id,
  type = TagTypes.Neutral
}) => {
  const tooltipId = id || DEFAULT_TOOLTIP_ID;

  return (
    <>
      <div
        data-tip
        data-for={tooltipId}
        className={classnames(
          'inline-block px-2.5 py-1 rounded-lg text-white text-center text-sm tracking-wide capitalize',
          TAG_COLORS[type]
        )}
      >
        {label || '--'}
      </div>
      {children && (
        <ReactTooltip id={tooltipId} place="top" effect="solid">
          <div className="w-52">
            <p>{children}</p>
          </div>
        </ReactTooltip>
      )}
    </>
  );
};

export default Tag;
